import { useAbTesting } from '@packages/abtesting';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SimilarProductsRecoSlider } from '@packages/recommendations';
import { Typography } from '@packages/shared';
import { useIntl } from 'react-intl';
import { SimilarRecoFragmentFragmentDoc } from '@packages/gql/generated/shopping/SimilarRecoFragmentFragmentDoc';
import { SlotBox } from '../SlotBox';
import { messages } from './messages';

/* GraphQL */ `
  fragment SimilarRecoFragment on Product {
    hasSeries
    promotion
    orderNumber
  }
`;

export type SimilarProductsProps = {
  data: FragmentType<typeof SimilarRecoFragmentFragmentDoc>;
};

const testId = '2023_09_reco_sequence';

export const SimilarProducts = ({ data }: SimilarProductsProps) => {
  const { hasSeries, orderNumber, promotion } = getFragmentData(
    SimilarRecoFragmentFragmentDoc,
    data,
  );
  const { formatMessage } = useIntl();

  // can be removed after abc test
  const { setOutcome, setRelevantProduct } = useAbTesting();

  return (
    <>
      <Typography variant="h2" component="header" sx={{ m: 2 }}>
        {formatMessage(messages.headline)}
      </Typography>
      <SlotBox>
        <SimilarProductsRecoSlider
          productId={`${orderNumber}${promotion}`}
          elementIndex={hasSeries ? 3 : 2}
          fetchOnThreshold
          pageTemplate="detailview"
          title={formatMessage(messages.title)}
          key={`${orderNumber}${3}`}
          // can be removed after abc test
          onSeen={() => setOutcome(testId, { SEEN: 1 })}
          onProductClick={(_, sku) => {
            setOutcome(testId, { COF_AA: 1 });
            setRelevantProduct(testId, sku, 'AA');
          }}
        />
      </SlotBox>
    </>
  );
};
